import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineWarrantyBadge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      clipPath="url(#a)"
    >
      <path d="M7.622 1.436a.525.525 0 0 1 .756 0l.86.894c.136.14.337.194.524.14l1.192-.343a.525.525 0 0 1 .655.378l.3 1.204a.53.53 0 0 0 .382.383l1.204.299c.29.071.46.369.379.655l-.344 1.192a.53.53 0 0 0 .14.523l.894.861a.525.525 0 0 1 0 .756l-.894.861a.53.53 0 0 0-.14.523l.344 1.193a.525.525 0 0 1-.379.654l-1.204.3a.53.53 0 0 0-.383.382l-.299 1.204a.525.525 0 0 1-.655.379l-1.192-.344a.53.53 0 0 0-.523.14l-.86.894a.525.525 0 0 1-.757 0l-.86-.894a.53.53 0 0 0-.524-.14l-1.192.344a.525.525 0 0 1-.655-.379l-.3-1.204a.53.53 0 0 0-.382-.383l-1.204-.299a.525.525 0 0 1-.378-.654l.343-1.193a.53.53 0 0 0-.14-.523l-.894-.86a.525.525 0 0 1 0-.757l.894-.86a.53.53 0 0 0 .14-.524l-.343-1.192a.525.525 0 0 1 .378-.655l1.204-.299a.53.53 0 0 0 .383-.383l.299-1.204a.525.525 0 0 1 .655-.378l1.192.343c.187.054.388 0 .523-.14z" />
      <path d="m10.591 6.031-3.57 4.463-1.785-1.339" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStreamlineWarrantyBadge;
